import type { UserDto } from './user.dto';
import type { AssignedSurveyDto } from './surveys/lib/assigned-survey.dto';
import { z } from 'zod';

export interface HospitalizationDto {
  id: number;
  note: string;

  memberId: string;
  hospital: string;
  hospitalInfo: string;
  // Admit
  admitComplaint: string;
  admitNotificationTime: string;
  admitType: string;
  admitDate: string;
  // Discharge
  dischargeNotificationTime: string;
  dischargeDate: string;
  dischargeDisposition: string;
  // Follow Up
  followUpDate: string;
  followUpType: string;
  requiresFollowUp: boolean;
  expectedSurveyCompletion: string;
  assignedSurveyId: number;

  // Tracking Timestamps
  attemptedAt: number;
  offeredAt: number;

  member: UserDto;
  isEnrolledInBehavioralHealth: boolean;
  isAssumed: boolean;
}

export interface HospitalizationFollowUpCountsDto {
  lastUpdatedAt: number;
  notAttempted: number;
  notOffered: number;
}

export interface CurrentAndPendingHospitalizationsDto {
  meta: {
    total: number;
    offeredCount: number;
    attemptedCount: number;
  };
  data: Record<string, number[]>;
  hospitalizations: HospitalizationDto[];
  allHospitalizations: HospitalizationDto[];
  assignedSurveys: AssignedSurveyDto[];
}

export const HospitalizationFormSchema = z
  .object({
    note: z.string().refine(
      value => {
        // Remove HTML tags and check if empty
        const plainText = value.replace(/<[^>]*>/g, '');
        const trimmed = plainText.trim();
        const isEmptyHtml =
          trimmed === '' || trimmed === null || trimmed === undefined;
        return !isEmptyHtml;
      },
      {
        message: 'Note is required',
      }
    ),
  })
  .strict();
export type HospitalizationForm = z.infer<typeof HospitalizationFormSchema>;
